import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import { Col, Row } from 'react-bootstrap'
import type { RouteDef } from '@ztechapps/common.contract'
import { LoadMoreButton } from '@ztechapps/webui.button'
import { WebuiIocKey, useInject } from '@ztechapps/webui.contract'
import { DataSuspense, ShowIf } from '@ztechapps/webui.util'
import { BlogBox } from '../BlogBox'
import { BlogListViewModeEnum } from './BlogListViewModeEnum'
import { BlogCategoryTreeView } from './BlogCategoryTreeView'
import { useBlogListContext } from './Context'
import { ListView } from './ListView'
import styles from './BlogCategoryTreeView/BlogCategoryTreeView.module.scss'

export const Layout = () => {
  const { list, error, loading, pageInfo, loadMoreEntries, sort, filter, viewMode, tenantFree } = useBlogListContext()
  const blogItemRoute = useInject<RouteDef>(WebuiIocKey.routes.blogItem)

  if (viewMode === BlogListViewModeEnum.Tree) return <BlogCategoryTreeView tenantFree={tenantFree} />

  return (
    <DataSuspense {...{ loading, error, isEmpty: isEmpty(list) }}>
      {viewMode === BlogListViewModeEnum.Grid ? (
        <div className={`${styles.shrinkable} flex-grow-1 overflow-x-hidden overflow-y-auto`}>
          <Row className="g-3">
            {map(list, (blog) => (
              <Col key={blog?._id} md={4}>
                <BlogBox {...blog} linkToPath={blogItemRoute.altPath({ _id: blog?._id })} />
              </Col>
            ))}
          </Row>
        </div>
      ) : (
        <ListView />
      )}
      <ShowIf condition={!error}>
        <LoadMoreButton {...{ dataArray: list, pageInfo, loadMoreEntries, loading, sort, filter }} />
      </ShowIf>
    </DataSuspense>
  )
}
